import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { currency } from './../../../../../helpers/';

class PromoModalItem extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            addedToBasket: false,
        };
    }

    addedPromotionToBasket() {

        const { addToBasket, promotion, network } = this.props;

        this.setState( { addedToBasket: true } );

        localStorage.setItem( "promo_added", 1 );

        addToBasket( promotion[0].package_id );

        if( parseInt( localStorage.promo_added, 10 ) === 1 ) {
			browserHistory.push( `/${ network }/basket` );
        }
    };

    promotionClaimed() {
        this.setState( {
            addedToBasket: true
        } );

        localStorage.setItem( "promo_added", 1 );
    };

    render() {
        const { isOffer, notOfferRight, notOfferLeft, promotion, premium } = this.props;

        // Pass details down to this component to dynamically add prices for premium/platinum packages

        let promotional_price = currency.convert( promotion[0].promotional_price );
        let base_price = currency.convert( promotion[0].base_price );
        const currencySign = promotional_price.substring( 0, 1 );

        return (
            <div className={ `${ !!isOffer && !!notOfferLeft && !!notOfferRight ? 'col-sm-offset-3 col-sm-6' : 'test' }` }>
                {
                    isOffer ?
	                    <div className="col-xs-12 col-sm-6 padding-none relative">
	                        <div className="promo-item promoted">
		                        <h1 className="h1">Gold</h1>
		                        <p className="p-tag networks">All Networks</p>
		                        <div className="price-promoted">
			                        <p className="p-tag title-type-of-offer"><span>Limited Offer</span></p>
			                        <div className="price"><span className="currency white">{ currencySign }</span>{ promotional_price.substring( 1, promotional_price.length ) }</div>
		                        </div>
		                        <p className="p-tag vat-info">{ `(excludes ${ currency.taxType() })` }</p>
		                        <div className="price-regular">
			                        <p className="p-tag title-type-of-offer">Regular Price</p>
			                        <div className="price"><span className="currency white">{ currencySign }</span>{ base_price.substring( 1, base_price.length ) }</div>
		                        </div>
                                <div className="padding-top">
                                    <button type="button" className="btn btn-primary" onClick={ () => this.addedPromotionToBasket() }>
                                        <span className="label">Claim your offer</span>
                                        <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                                    </button>
                                </div>
	                        </div>
	                    </div>
                        :
                        (
                            premium ?
                                <div className={ `hidden-xs col-sm-3 padding-none relative ${ notOfferRight ? ' item-right' : '' }${ notOfferLeft ? ' item-left' : '' }` }>
                                    <div className="promo-item promoted-item-left">
	                                    <h1 className="h1 light-grey">Premium</h1>
	                                    <p className="p-tag networks">Single Network</p>
	                                    <div className="price-regular">
		                                    <div className="price"><span className="currency">{ currencySign }</span>{ currency.convert( 399.00 ) }</div>
	                                    </div>
                                        <p className="p-tag">{ `(excludes ${ currency.taxType() })` }</p>
                                    </div>
                                </div>
                                :
                                <div className={ `hidden-xs col-sm-3 padding-none relative ${ notOfferRight ? ' item-right' : '' }${ notOfferLeft ? ' item-left' : '' }` }>
                                    <div className="promo-item promoted-item-right">
	                                    <h1 className="h1 light-grey">Platinum</h1>
	                                    <p className="p-tag networks">All Networks</p>
	                                    <div className="price-regular">
		                                    <div className="price"><span className="currency">{ currencySign }</span>{ currency.convert( 1499.00 ) }</div>
	                                    </div>
	                                    <p className="p-tag">{ `(excludes ${ currency.taxType() })` }</p>
                                    </div>
                                </div>
                        )
                }
            </div>
        )
    };
}

const mapStateToProps = state => ({ basket : state.transactions.basket });

export default connect( mapStateToProps )( PromoModalItem );



// WEBPACK FOOTER //
// src/client/components/site/features/promos/elements/PromoModalItem.js